var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"featuredUsersWarning"},[_c('p',{staticClass:"featuredUsersWarning__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"featuredUsersWarning__description"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }